import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

const Loading = () => {
  return (
    <Stack
      width="100vw"
      height="100vh"
      alignItems="center"
      justifyContent="center"
    >
      <Container maxWidth="sm">
        <Stack rowGap={2} alignItems="center">
          <Typography color="primary" fontWeight={600}>
            Preparando um ambiente seguro...
          </Typography>
          <LinearProgress sx={{ width: "100%" }} color="primary" />
        </Stack>
      </Container>
    </Stack>
  );
};

export default Loading;
